import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["businessField", "w9BusinessName"]

  connect() {
    this.toggleBusinessFields()
  }

  toggleBusinessFields() {
    const enrollmentType = document.querySelector('[name="pure_perk_membership[enrollment_type]"]')?.value
    const businessFields = document.querySelectorAll('.business-field')

    if (enrollmentType === 'Business') {
      businessFields.forEach(field => {
        field.classList.remove('hidden')
      })
    } else {
      businessFields.forEach(field => {
        field.classList.add('hidden')
      })
    }

    // Update W-9 form enrollment type
    this.updateW9EnrollmentType(enrollmentType)
  }

  updateW9EnrollmentType(enrollmentType) {
    // Find the W-9 form controller element
    const w9FormElement = document.querySelector('[data-controller="w9-form"]')

    if (w9FormElement && enrollmentType) {
      // Update the enrollment type value attribute
      w9FormElement.setAttribute('data-w9-form-enrollment-type-value', enrollmentType)

      // Trigger the stimulus controller to update visibility
      const w9Controller = this.application.getControllerForElementAndIdentifier(w9FormElement, 'w9-form')
      if (w9Controller) {
        w9Controller.toggleEnrollmentTypeFields()
      }
    }
  }

  syncCompanyNameToW9(event) {
    // Sync the company name value to the W-9 business name hidden field
    if (this.hasW9BusinessNameTarget) {
      this.w9BusinessNameTarget.value = event.target.value
    }
  }
}
